/* Promo NFL · playbook doodles (snippets/nfl-playbook.liquid)
   Builds a marker-on-whiteboard football play in SVG and RUNS it on a timeline:
   every O and X moves along its own route at the same time, the route line trails
   behind its piece, linemen take short block steps, the defense drops / rushes /
   chases, and the ball goes center -> QB -> receiver on a dashed arc.
   Timeline = scroll progress through the host section (0 -> 1), eased per leg.
   data-mode="time" runs it on a loop while visible instead (home banner).
   prefers-reduced-motion -> the finished play is drawn once, static. */
(function () {
  'use strict';
  var hosts = document.querySelectorAll('[data-nfl-play]');
  if (!hosts.length) return;
  var NS = 'http://www.w3.org/2000/svg';
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var REDUCED = !!(mq && mq.matches);

  /* ---------- play library (viewBox 0 0 1000 560, line of scrimmage y = 330) ----------
     leg: [d, from, to, opts]   opts: l = route line (trails the piece), h = highlighter,
     s = dashed, e = 'a' arrow | 'b' block mark at the end. A piece waits on its first point. */
  function O(legs) { return { k: 'o', legs: legs }; }
  function X(legs) { return { k: 'x', legs: legs }; }
  function B(legs) { return { k: 'ball', legs: legs }; }
  var BLK = { l: 1, e: 'b' }, RTE = { l: 1, e: 'a' }, HL = { l: 1, h: 1, e: 'a' }, THROW = { l: 1, s: 1 }, STEP = {};

  function oline(dx) {
    dx = dx || 0;
    return [
      O([['M400 354 L' + (392 + dx) + ' 338', .06, .26, BLK]]),
      O([['M450 352 L' + (454 + dx) + ' 336', .06, .26, BLK]]),
      O([['M500 350 L' + (500 + dx) + ' 334', .07, .27, BLK]]),
      O([['M550 352 L' + (546 + dx) + ' 336', .06, .26, BLK]]),
      O([['M600 354 L' + (608 + dx) + ' 338', .06, .26, BLK]])
    ];
  }

  var PLAYS = {
    /* Dinámica: slant por la izquierda, "go" profunda por la derecha (resaltada), out del slot, swing del RB */
    slant: function () {
      return oline().concat([
        O([['M500 420 L500 470', .05, .3, STEP]]),                                            // QB drop
        O([['M500 490 C560 500 640 492 720 430', .16, .62, RTE]]),                            // RB swing
        O([['M120 352 L126 300 L330 170', .1, .7, RTE]]),                                     // X slant
        O([['M680 360 L690 262 L812 252', .1, .66, RTE]]),                                    // slot out
        O([['M880 352 L882 200 C884 120 878 80 858 44', .1, .95, HL]]),                       // Z go
        X([['M382 300 L396 336', .07, .27, STEP]]), X([['M470 298 L464 328', .07, .27, STEP]]),
        X([['M530 298 L540 328', .07, .27, STEP]]), X([['M620 300 L602 336', .07, .27, STEP]]),
        X([['M400 230 L364 196', .14, .6, STEP]]),                                            // LB drop
        X([['M500 220 L522 182 L566 170', .14, .62, STEP]]),                                  // LB hook
        X([['M600 230 L652 246 L700 322', .16, .66, STEP]]),                                  // LB chases RB
        X([['M130 250 L138 222 L300 178', .12, .74, STEP]]),                                  // CB trails the slant
        X([['M870 250 L872 170 C874 110 868 86 846 70', .12, .96, STEP]]),                    // CB on the go
        X([['M330 120 L360 112 L404 142', .18, .7, STEP]]),
        X([['M670 120 C740 96 790 84 836 82', .2, .92, STEP]]),                               // S rotates over the top
        B([['M500 350 L500 470', .04, .3, STEP], ['M500 470 Q700 120 858 44', .74, .97, THROW]])
      ]);
    },
    /* Fechas: opción a la derecha, pitch al corredor que corre por la banda (resaltado) */
    option: function () {
      return oline(18).concat([
        O([['M500 420 Q560 446 642 420', .1, .6, STEP]]),                                     // QB rolls right
        O([['M500 490 Q612 512 742 452', .14, .68, STEP], ['M742 452 Q826 402 868 282 L880 120', .7, .98, HL]]),
        O([['M120 352 L132 232 L332 104', .1, .8, RTE]]),                                     // X post
        O([['M880 352 L862 302 L804 282', .1, .4, BLK]]),                                     // Z crack block
        O([['M680 360 L652 332', .08, .3, BLK]]),                                             // TE down block
        X([['M382 300 L404 334', .07, .28, STEP]]), X([['M470 298 L486 328', .07, .28, STEP]]),
        X([['M530 298 L562 332', .07, .28, STEP]]),
        X([['M620 300 Q640 360 652 404', .1, .58, STEP]]),                                    // DE chases the QB
        X([['M400 230 L470 250 L590 300', .14, .76, STEP]]),
        X([['M500 220 L604 262 L724 304', .14, .8, STEP]]),
        X([['M600 230 Q700 250 806 292', .14, .74, STEP]]),                                   // LB meets the crack block
        X([['M130 250 L182 200 L312 122', .12, .82, STEP]]),
        X([['M870 250 L862 268 L872 214', .12, .7, STEP]]),
        X([['M330 120 L430 124 L566 184', .2, .9, STEP]]),
        X([['M670 120 Q770 160 862 196', .2, .9, STEP]]),                                     // S fills the alley
        B([['M500 350 L500 420', .03, .12, STEP], ['M500 420 Q560 446 642 420', .12, .6, STEP],
           ['M642 420 Q700 404 742 452', .6, .68, THROW], ['M742 452 Q826 402 868 282 L880 120', .7, .98, STEP]])
      ]);
    },
    /* Bases: pantalla al corredor, los linieros salen a bloquear al frente (corrida resaltada) */
    screen: function () {
      return [
        O([['M400 354 L390 380', .08, .3, BLK]]),
        O([['M450 352 L444 376', .08, .3, BLK]]),
        O([['M500 350 L522 382 L642 402', .24, .62, BLK]]),
        O([['M550 352 L592 382 L684 420 L724 382', .24, .7, BLK]]),
        O([['M600 354 L652 380 L742 380 L784 330', .24, .72, BLK]]),
        O([['M500 420 L500 482 L490 502', .05, .46, STEP]]),                                  // QB deep drop
        O([['M500 490 Q562 512 642 470', .2, .56, STEP], ['M642 470 Q724 420 772 300 L792 130', .66, 1, HL]]),
        O([['M120 352 L126 110', .1, .9, RTE]]),
        O([['M880 352 L886 130', .1, .9, RTE]]),                                              // clears out the CB
        X([['M382 300 L412 392', .08, .5, STEP]]),
        X([['M470 298 L482 364 L492 444', .08, .55, STEP]]),                                  // DL let through
        X([['M530 298 L520 372 L506 452', .08, .55, STEP]]),
        X([['M620 300 L582 382', .08, .5, STEP]]),
        X([['M400 230 L380 196', .16, .5, STEP]]),
        X([['M500 220 L544 300', .16, .6, STEP]]),
        X([['M600 230 L642 300 L704 368', .2, .72, STEP]]),
        X([['M130 250 L132 120', .12, .9, STEP]]),
        X([['M870 250 L874 140', .12, .9, STEP]]),
        X([['M330 120 L360 160 L420 220', .3, .9, STEP]]),
        X([['M670 120 Q724 200 784 262', .3, .92, STEP]]),
        B([['M500 350 L500 496', .03, .3, STEP], ['M490 502 Q566 438 642 470', .55, .65, THROW], ['M642 470 Q724 420 772 300 L792 130', .66, 1, STEP]])
      ];
    },
    /* FAQ: Hail Mary, cuatro receptores profundos, el balón vuela en arco largo */
    hailmary: function () {
      return oline().concat([
        O([['M500 420 L500 490 L524 504', .05, .55, STEP]]),
        O([['M500 470 L562 448', .16, .4, BLK]]),                                             // RB stays in to block
        O([['M120 352 L118 60', .1, .9, RTE]]),
        O([['M300 360 L332 200 L362 64', .1, .92, HL]]),
        O([['M700 360 L668 200 L640 64', .1, .92, RTE]]),
        O([['M880 352 L882 60', .1, .9, RTE]]),
        X([['M382 300 L424 400 L474 468', .08, .6, STEP]]),
        X([['M470 298 L480 360', .08, .3, STEP]]), X([['M530 298 L520 360', .08, .3, STEP]]),
        X([['M620 300 L592 420 L546 482', .08, .62, STEP]]),
        X([['M400 230 L398 140', .14, .7, STEP]]), X([['M500 220 L482 128', .14, .7, STEP]]), X([['M600 230 L604 140', .14, .7, STEP]]),
        X([['M130 250 L128 80', .12, .9, STEP]]), X([['M870 250 L870 80', .12, .9, STEP]]),
        X([['M330 120 L352 74', .2, .9, STEP]]), X([['M670 120 L624 74', .2, .9, STEP]]),
        B([['M500 350 L500 486', .03, .3, STEP], ['M500 486 L524 504', .3, .55, STEP], ['M524 504 Q560 20 362 64', .66, .96, THROW]])
      ]);
    },
    /* Banner del home: jugada corta */
    mini: function () {
      return [
        O([['M450 352 L454 336', .06, .22, BLK]]), O([['M500 350 L500 334', .06, .22, BLK]]), O([['M550 352 L546 336', .06, .22, BLK]]),
        O([['M500 420 L500 462', .05, .3, STEP]]),
        O([['M640 360 L650 250 L560 150', .1, .85, HL]]),
        O([['M360 360 L350 260 L250 200', .1, .8, RTE]]),
        X([['M470 298 L462 326', .06, .22, STEP]]), X([['M530 298 L540 326', .06, .22, STEP]]),
        X([['M600 220 L590 190 L570 166', .14, .82, STEP]]), X([['M400 220 L380 230 L300 214', .14, .8, STEP]]),
        B([['M500 350 L500 462', .04, .3, STEP], ['M500 462 Q560 250 560 150', .7, .9, THROW]])
      ];
    }
  };

  /* ---------- helpers ---------- */
  function el(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return -(Math.cos(Math.PI * t) - 1) / 2; }
  var uid = 0;

  function build(host) {
    var key = host.getAttribute('data-nfl-play');
    var players = (PLAYS[key] || PLAYS.slant)();
    var id = 'nflpb' + (++uid);
    var svg = el('svg', { viewBox: '0 0 1000 560', fill: 'none', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', focusable: 'false' });
    var defs = el('defs', {}, svg);
    var f = el('filter', { id: id + 'r', x: '-2%', y: '-2%', width: '104%', height: '104%' }, defs);
    el('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.02', numOctaves: '2', seed: String(key.length), result: 'n' }, f);
    el('feDisplacementMap', { in: 'SourceGraphic', in2: 'n', scale: '3', xChannelSelector: 'R', yChannelSelector: 'G' }, f);
    var g = el('g', { 'class': 'nfl-pb__g', filter: 'url(#' + id + 'r)' }, svg);
    var gHL = el('g', {}, g), gLines = el('g', {}, g), gMarks = el('g', {}, g), gPieces = el('g', {}, g);
    host.appendChild(svg); // in the DOM before measuring paths

    var los = el('path', { 'class': 'nfl-pb__los', d: 'M30 330 C300 332 700 328 970 330', pathLength: '1' }, gLines);
    var draws = [{ node: los, a: 0, b: .06 }];
    var pops = [], movers = [], n = 0;

    players.forEach(function (pl) {
      var legs = pl.legs.map(function (L) {
        var d = L[0], a = L[1], b = L[2], o = L[3] || {};
        var geo = el('path', { d: d, 'class': 'nfl-pb__geo' }, gLines);
        var len = geo.getTotalLength();
        if (o.h) draws.push({ node: el('path', { d: d, 'class': 'nfl-pb__hl', pathLength: '1' }, gHL), a: a, b: b });
        if (o.l && o.s) {
          var m = el('mask', { id: id + 'm' + (++n), maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: 1000, height: 560 }, defs);
          draws.push({ node: el('path', { d: d, 'class': 'nfl-pb__maskline', pathLength: '1' }, m), a: a, b: b });
          el('path', { d: d, 'class': 'nfl-pb__dash', mask: 'url(#' + id + 'm' + n + ')' }, gLines);
        } else if (o.l) {
          draws.push({ node: el('path', { d: d, 'class': 'nfl-pb__line', pathLength: '1' }, gLines), a: a, b: b });
        }
        if (o.e) {
          var P = geo.getPointAtLength(len), Q = geo.getPointAtLength(Math.max(0, len - 8));
          var ang = Math.atan2(P.y - Q.y, P.x - Q.x), mark;
          if (o.e === 'a') {
            var s = 17, w = 0.5;
            mark = 'M' + (P.x - s * Math.cos(ang - w)).toFixed(1) + ' ' + (P.y - s * Math.sin(ang - w)).toFixed(1) +
              ' L' + P.x.toFixed(1) + ' ' + P.y.toFixed(1) +
              ' L' + (P.x - s * Math.cos(ang + w)).toFixed(1) + ' ' + (P.y - s * Math.sin(ang + w)).toFixed(1);
          } else {
            var px = Math.cos(ang + Math.PI / 2) * 13, py = Math.sin(ang + Math.PI / 2) * 13;
            mark = 'M' + (P.x - px).toFixed(1) + ' ' + (P.y - py).toFixed(1) + ' L' + (P.x + px).toFixed(1) + ' ' + (P.y + py).toFixed(1);
          }
          pops.push({ node: el('path', { d: mark, 'class': 'nfl-pb__line nfl-pb__end' }, gMarks), at: b - 0.01 });
        }
        return { geo: geo, len: len, a: a, b: b };
      });
      var piece;
      if (pl.k === 'o') { piece = el('g', { 'class': 'nfl-pb__o' }, gPieces); el('circle', { r: 13 }, piece); }
      else if (pl.k === 'x') { piece = el('g', { 'class': 'nfl-pb__x' }, gPieces); el('path', { d: 'M-11 -11 L11 11 M11 -11 L-11 11' }, piece); }
      else {
        piece = el('g', { 'class': 'nfl-pb__ball' }, gPieces);
        el('ellipse', { rx: 13, ry: 8 }, piece);
        el('path', { d: 'M-6 0 H6 M-3 -3.5 V3.5 M0 -3.5 V3.5 M3 -3.5 V3.5', 'class': 'nfl-pb__lace' }, piece);
      }
      movers.push({ node: piece, legs: legs, ball: pl.k === 'ball', last: '' });
    });

    return { sec: host.closest('section') || host.parentElement, svg: svg, draws: draws, pops: pops, movers: movers, visible: false, mode: host.getAttribute('data-mode') || 'scroll' };
  }

  function paint(P, p) {
    var op = clamp01(p / 0.04 + 0.2).toFixed(3);
    if (op !== P.op) { P.op = op; P.svg.style.opacity = op; }
    P.draws.forEach(function (d) {
      var v = (1 - ease(clamp01((p - d.a) / (d.b - d.a)))).toFixed(4);
      if (v !== d.v) { d.v = v; d.node.style.strokeDashoffset = v; }
    });
    P.pops.forEach(function (o) {
      var on = p >= o.at;
      if (on !== o.on) { o.on = on; o.node.style.opacity = on ? '1' : '0'; }
    });
    P.movers.forEach(function (m) {
      var leg = m.legs[0], t = 0;
      for (var i = 0; i < m.legs.length; i++) {
        if (p >= m.legs[i].a) { leg = m.legs[i]; t = ease(clamp01((p - leg.a) / (leg.b - leg.a))); }
      }
      var at = leg.len * t, pt = leg.geo.getPointAtLength(at);
      var tr = 'translate(' + pt.x.toFixed(1) + ' ' + pt.y.toFixed(1) + ')';
      if (m.ball) {
        var q = leg.geo.getPointAtLength(Math.min(leg.len, at + 2)), r = leg.geo.getPointAtLength(Math.max(0, at - 2));
        tr += ' rotate(' + (Math.atan2(q.y - r.y, q.x - r.x) * 180 / Math.PI).toFixed(1) + ')';
      }
      if (tr !== m.last) { m.last = tr; m.node.setAttribute('transform', tr); }
    });
  }

  var plays = Array.prototype.map.call(hosts, build);

  if (REDUCED) { plays.forEach(function (P) { paint(P, 1); }); return; }

  function progress(P) {
    var r = P.sec.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    // starts when the section top reaches 85% of the viewport, ends as its bottom passes ~60%
    return clamp01((vh * 0.85 - r.top) / (r.height + vh * 0.25));
  }

  var ticking = false;
  function frame() {
    ticking = false;
    plays.forEach(function (P) { if (P.mode !== 'time' && P.visible && P.driven == null) paint(P, progress(P)); });
  }
  function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }

  // time mode (home banner): run, hold, replay while visible
  function runTimed(P) {
    var RUN = 4200, HOLD = 2600, t0 = null;
    function step(ts) {
      if (!P.visible) { P.raf = 0; return; }
      if (t0 === null) t0 = ts;
      paint(P, Math.min(1, ((ts - t0) % (RUN + HOLD)) / RUN));
      P.raf = window.requestAnimationFrame(step);
    }
    if (!P.raf) P.raf = window.requestAnimationFrame(step);
  }

  plays.forEach(function (P) { paint(P, P.mode === 'time' ? 0 : progress(P)); });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        plays.forEach(function (P) {
          if (P.sec !== e.target) return;
          P.visible = e.isIntersecting;
          if (P.mode === 'time' && P.visible) runTimed(P);
        });
      });
      request();
    }, { rootMargin: '15% 0px 15% 0px' });
    plays.forEach(function (P) { io.observe(P.sec); });
  } else {
    plays.forEach(function (P) { P.visible = true; if (P.mode === 'time') runTimed(P); });
  }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  // expose for previews / screenshots: NflPlaybook.paintAll(p)
  // drive(section, p): an external timeline (assets/nfl-explica.js) runs the play of that
  // section instead of the scroll; release() hands every play back to the scroll.
  window.NflPlaybook = {
    paintAll: function (p) { plays.forEach(function (P) { paint(P, p); }); },
    drive: function (sec, p) {
      plays.forEach(function (P) { if (P.sec === sec) { P.driven = clamp01(p); paint(P, P.driven); } });
    },
    release: function () { plays.forEach(function (P) { P.driven = null; }); request(); }
  };
})();
